import format from "date-fns/format"
import DateFnsUtils from "@date-io/date-fns"

export default class DateFnsUtilsEx extends DateFnsUtils {
  getCalendarHeaderText(date) {
    if (this.locale.code === `ja`) {
      return format(date, `yyyy年 MMM`, {
        locale: this.locale,
      })
    }
    return super.getCalendarHeaderText(date)
  }

  getDatePickerHeaderText(date) {
    if (this.locale.code === `ja`) {
      return format(date, `MMMd日`, {
        locale: this.locale,
      })
    }

    return super.getDatePickerHeaderText(date)
  }

  getYearText(date) {
    if (this.locale.code === `ja`) {
      return format(date, `yyyy年`, {
        locale: this.locale,
      })
    }

    return super.getYearText(date)
  }
}
